var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 19,
    viewBox: "0 0 34 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4532 17.7253C16.3075 18.5795 17.6925 18.5795 18.5468 17.7253L32.468 3.8041C33.3222 2.94983 33.3222 1.56478 32.468 0.710505C31.6137 -0.143767 30.2286 -0.143767 29.3744 0.710505L17 13.0849L4.62563 0.710506C3.77136 -0.143766 2.38631 -0.143766 1.53204 0.710506C0.677766 1.56478 0.677766 2.94983 1.53204 3.8041L15.4532 17.7253ZM14.8125 15.1785L14.8125 16.1785L19.1875 16.1785L19.1875 15.1785L14.8125 15.1785Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow6);
export default __webpack_public_path__ + "static/media/Arrow 6.68a24e889374380e1e6dc1165045a421.svg";
export { ForwardRef as ReactComponent };